import { SVGProps } from 'react';
import { tokens } from '../../core/theme';

type LampIconProps = SVGProps<SVGSVGElement> & { color?: string };

export const LampIcon = ({
  width = 24,
  height = 24,
  color = tokens.colors.brand.red.DEFAULT,
  ...props
}: LampIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24.01 24.01"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.6944 15.8213H9.31817"
        stroke={color}
        strokeWidth={1.59167}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.07384 15.5713C7.26352 14.2937 6.4891 11.9907 7.15962 9.87887C7.83014 7.76699 9.79115 6.33256 12.0069 6.3332C14.2227 6.33385 16.1829 7.76941 16.8522 9.88168C17.5215 11.9939 16.7457 14.2964 14.9346 15.573C14.6978 15.7315 14.5532 15.9957 14.5474 16.2806V18.6254C14.5475 19.1873 14.3243 19.7263 13.9269 20.1236C13.5296 20.5209 12.9907 20.744 12.4288 20.744H11.5814C11.0195 20.744 10.4806 20.5209 10.0832 20.1236C9.6859 19.7263 9.46272 19.1873 9.4628 18.6254V16.284C9.45718 15.9972 9.312 15.7312 9.07384 15.5713Z"
        stroke={color}
        strokeWidth={1.59167}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3717 5.37364L17.735 6.01029"
        stroke={color}
        strokeWidth={1.59167}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.27511 17.4702L5.63845 18.1069"
        stroke={color}
        strokeWidth={1.59167}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0088 11.7403H20.1084"
        stroke={color}
        strokeWidth={1.59167}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.90169 11.7403H3.00131"
        stroke={color}
        strokeWidth={1.59167}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3717 18.1069L17.735 17.4702"
        stroke={color}
        strokeWidth={1.59167}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.27511 6.0103L5.63845 5.37364"
        stroke={color}
        strokeWidth={1.59167}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0051 3.63688V2.7365"
        stroke={color}
        strokeWidth={1.59167}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
